module.exports = __webpack_public_path__ + "img/icon37.4d0be1f6.png";